import { useCallback, useRef, useState } from 'react';

import classNames from 'classnames';
import { observer } from 'mobx-react';

import { useHiddenBodyOverflow } from '../../../hooks/useHiddenBodyOverflow';
import { useMinigameMessages } from '../../../hooks/useMinigameMessages';
import { logToNewRelic } from '../../../services/debug';
import { useStores } from '../../../stores/useStores';

import { LoaderCover } from './LoaderCover';
import classes from './MinigamesDialog.module.scss';

export const MinigamesDialog = observer(() => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const { minigamesStore } = useStores();

  const [isReady, setIsReady] = useState(false);

  useHiddenBodyOverflow(true);

  const onIframeLoad = () => {
    void logToNewRelic(
      'MinigamesDialog iframe loaded',
      'MinigamesDialog iframe loaded: ' +
        JSON.stringify({
          src: iframeRef.current?.src,
        }),
      'debug',
    );
  };

  const onAuthenticated = useCallback(() => setIsReady(true), []);
  const onClosed = useCallback(() => setIsReady(false), []);

  useMinigameMessages({ iframeRef, onAuthenticated, onClosed });

  return (
    <div className={classes.minigamesDialog}>
      <div className={classes.cover}>
        <div className={classes.dialog}>
          <iframe
            ref={iframeRef}
            className={classNames(classes.iframe, !isReady && classes.prepare)}
            src={minigamesStore.iframeData?.src || ''}
            title="Minigames"
            onLoad={onIframeLoad}
          />
        </div>
        {!isReady && <LoaderCover />}
      </div>
    </div>
  );
});
